import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorOpen, faEnvelope, faPencilAlt, faTrashCan, faUserShield, faChalkboardUser, faUserGraduate } from "@fortawesome/free-solid-svg-icons";
import "./PeopleList.css";

// One person row of /students and /users. Same shape as the session rows of the
// high-tension modules: index bubble, identity, meta chips, icon actions.
export interface Person {
    userId: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    email?: string;
    grade?: string;
    type?: string;
    admin?: boolean | number;
}

export interface PeopleListProps {
    people: Person[];
    en?: boolean;
    /** Show the account-role badge (admin / teacher / student). */
    showRole?: boolean;
    emptyText: string;
    onEdit: (p: Person) => void;
    onRemove: (p: Person) => void;
}

const roleOf = (p: Person, en?: boolean) => {
    if (p.admin) return { key: "admin", label: en ? "Admin" : "Administrator", icon: faUserShield };
    if (p.type === "teacher") return { key: "teacher", label: en ? "Teacher" : "Profesor", icon: faChalkboardUser };
    return { key: "student", label: en ? "Student" : "Elev", icon: faUserGraduate };
};

const PeopleList = ({ people, en, showRole, emptyText, onEdit, onRemove } : PeopleListProps) => {
    if (!people.length) return <div className="people-empty"><h2>{emptyText}</h2></div>;

    return (
        <div className="people-rows">
            {people.map((p, idx) => {
                const role = roleOf(p, en);
                const name = [p.firstName, p.lastName].filter(Boolean).join(" ") || p.username || "—";
                return (
                    <div className="people-row" key={p.userId || idx}>
                        <div className="people-index">{idx + 1}</div>

                        <div className="people-identity">
                            <span className="people-name">{name}</span>
                            <span className="people-username">@{p.username}</span>
                        </div>

                        <div className="people-meta">
                            <span className="people-chip" title={p.email || ""}>
                                <FontAwesomeIcon icon={faEnvelope} />
                                {p.email || "—"}
                            </span>
                            <span className="people-chip">
                                <FontAwesomeIcon icon={faDoorOpen} />
                                {p.grade || (en ? "Undefined" : "Nedefinit")}
                            </span>
                            {showRole ? (
                                <span className={`people-role ${role.key}`}>
                                    <FontAwesomeIcon icon={role.icon} />
                                    {role.label}
                                </span>
                            ) : null}
                        </div>

                        <div className="people-actions">
                            <button
                                type="button"
                                className="people-btn"
                                data-tip={en ? "Edit" : "Editează"}
                                aria-label={`${en ? "Edit" : "Editează"} ${name}`}
                                onClick={() => onEdit(p)}
                            >
                                <FontAwesomeIcon icon={faPencilAlt} />
                            </button>

                            <button
                                type="button"
                                className="people-btn remove"
                                data-tip={en ? "Remove" : "Șterge"}
                                aria-label={`${en ? "Remove" : "Șterge"} ${name}`}
                                onClick={() => onRemove(p)}
                            >
                                <FontAwesomeIcon icon={faTrashCan} />
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default PeopleList;
